module.exports = __webpack_public_path__ + "static/media/dpdk.3b149662.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/dpdk.webp
// module id = 616
// module chunks = 0